import React, { useState, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Autocomplete, Button, CardContent, InputAdornment, TextField, styled } from '@mui/material';
import { useParams } from 'react-router';
import parsePhoneNumberFromString from 'libphonenumber-js';
import { countries } from '../_mock';
import Iconify from './Iconify';
import CustomModal from './CustomModal';
import { DEFAULT_COUNTRY_SELECTIONS } from '../config';
import useLocales from '../hooks/useLocales';

const InputBorder = styled('div')(() => ({
  height: 'fit-content',
  position: 'relative',
  padding: 2,
  flex: 1,
  borderRadius: '8px',
  background: `linear-gradient(90deg, #BC8001 0%, #C8941C 17.62%, #FAEB9A 26.88%, #C8941C 32.84%, #C8941C 38.5%, #FAEB9A 43.4%, #FAEB9A 52.96%, #C8941C 59.75%, #C8941C 63.11%, #FAEB9A 72.02%, #C8941C 79.16%, #BC8001 100%)`,
}));

const Input = styled(TextField)(() => ({
  color: '#000',
  fontWeight: 700,
  fontSize: 14,
  flexGrow: 1,
  width: '100%',
  background: 'linear-gradient(0deg, #C4C4C4, #FCFCFC, #D2D2D2)',
  borderRadius: 8,
  input: {
    color: '#000',
  },
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      border: 'none',
    },
    '&:hover fieldset': {
      border: 'none',
    },
    '&.Mui-focused fieldset': {
      border: 'none',
    },
  },
}));

const getCountryCodeObj = (code) => {
  let countryCode = null;
  if (code) {
    const foundCode = countries.find((x) => x?.code === code);
    if (foundCode) countryCode = foundCode;
  }

  return countryCode;
};

const PhonenumberTextField = ({ onChange, value, showCountrySelections = true, ...others }) => {
  const [textFieldValue, setTextFieldValue] = useState(value || '');

  const params = useParams();

  const { translate } = useLocales();

  const [openCodeSelect, setOpenCodeSelect] = useState(false);

  const country = useMemo(() => {
    const _countryCode = process.env.REACT_APP_COUNTRY_CODE || '';

    const _country = getCountryCodeObj(_countryCode);

    if (_country) return _country;
    return {};
  }, [params]);

  useEffect(() => {
    if (value) {
      const phoneNumber = parsePhoneNumberFromString(value, country?.code);

      if (phoneNumber) {
        // const _country = countries.find((c) => c.phone === phoneNumber.countryCallingCode);
        // if (_country && _country.code !== country?.code) {
        //   setCountry(_country);
        // }
        setTextFieldValue(phoneNumber.nationalNumber);
      } else {
        setTextFieldValue(value);
      }
    } else {
      setTextFieldValue(value);
    }
  }, [value, country]);

  // const handleCountryChange = (country) => {
  //   setCountry(country);
  //   if (country) {
  //     onChange(`+${country.phone}`);
  //   }
  // };

  const handleTextFieldChange = (event) => {
    const phone = event.target.value;
    const phoneNumber = parsePhoneNumberFromString(phone, country?.code);

    if (phoneNumber) {
      onChange(phoneNumber.number);
    } else {
      onChange(phone);
    }
  };

  // const [openMenu, setOpenMenuActions] = useState(null);

  // const handleOpenMenu = (event) => {
  //   setOpenMenuActions(event.currentTarget);
  // };

  // const handleCloseMenu = () => {
  //   setOpenMenuActions(null);
  // };

  const handleOpenMenu = () => {
    setOpenCodeSelect(true);
  };

  const handleCloseMenu = () => {
    setOpenCodeSelect(false);
  };

  return (
    <InputBorder>
      <Input
        value={textFieldValue}
        sx={{ position: 'relative', color: 'grey !important' }}
        InputProps={{
          startAdornment: showCountrySelections ? (
            <InputAdornment position="start" sx={{ position: 'relative', color: '#000', fontSize: 'inherit', }}>
              {/* <Button
                variant="text"
                size="small"
                onClick={handleOpenMenu}
                sx={{ color: '#000', fontSize: '14px', p: 0, minWidth: 'unset', mr: 0.5 }}
                tabIndex={-1}
              >
                {country?.code}
                <Iconify icon={'mingcute:down-fill'} />
              </Button> */}
              +{country?.phone}
            </InputAdornment>
          ) : (
            {}
          ),
          sx: { fontSize: '14px' },
        }}
        {...others}
        onChange={handleTextFieldChange}
      />
      {/* <CustomModal
        fullWidth
        maxWidth="xs"
        title={translate('select_country_code')}
        open={openCodeSelect}
        onClose={handleCloseMenu}
        sx={{ border: '1px solid grey' }}
      >
        <CardContent>
          <Autocomplete
            // disablePortal
            fullWidth
            value={country}
            options={
              DEFAULT_COUNTRY_SELECTIONS && DEFAULT_COUNTRY_SELECTIONS?.length
                ? countries.filter((x) => DEFAULT_COUNTRY_SELECTIONS.includes(x?.code))
                : countries
            }
            getOptionLabel={(option) => `${option.label} +${option.phone}`}
            onChange={(e, v) => handleCountryChange(v)}
            renderInput={(params) => (
              <TextField fullWidth {...params} label="Country Code" sx={{ fontSize: 'inherit' }} />
            )}
            sx={{ color: 'grey', borderColor: 'grey', borderRadius: 1, fontSize: 'inherit' }}
          />
        </CardContent>
      </CustomModal> */}
    </InputBorder>
  );
};

PhonenumberTextField.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  showCountrySelections: PropTypes.bool,
};

export default PhonenumberTextField;
